// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autosize from 'autosize';

export default class NoteTextArea extends Component {
  componentDidMount() {
    autosize(this.input);
    this.input.focus();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <textarea
        ref={(input) => { this.input = input; }}
        name="note"
        onBlur={this.props.handleBlur}
        defaultValue={this.props.content}
        dir="auto"
      />
    );
  }
}

NoteTextArea.propTypes = {
  content: PropTypes.string,
  handleBlur: PropTypes.func
};
